module.exports = __webpack_public_path__ + "img/Header_Desktop_Logo.85bd05e5.png";